import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { checkPermission, getAllPermissionsByUnit } from '../../../../utils/permission';

const useRecordsPermissions = (name) => {
  const navigate = useNavigate();
  const permissions = useSelector((state) => state.user.permissions);
  const company = useSelector((state) => state.user.company);
  const [permissionsFromForm, setPermissionsFromForm] = useState(null);

  const currentForm = decodeURIComponent(name);
  const formName = currentForm.replace("obj_", "");

  useEffect(() => {
    if (company && permissions) {
      const permissionFromFormData = getAllPermissionsByUnit(permissions, company.unitId, [
        'INSERT_DATA_IN_FORM',
        'EDIT_DATA_IN_FORM',
        'VIEW_DATA_FROM_FORM',
        'VIEW_DATA_ARCHIVED_FROM_FORM',
        'IMPORT_DATA_IN_FORM',
        'DELETE_DATA_IN_FORM'
      ]).filter(item => item.context && item.context.entity_type === "form" && item.context.entity_name === formName);

      if (permissionFromFormData.length === 0) {
        navigate("/403");
      }
      setPermissionsFromForm(permissionFromFormData);
    }
  }, [permissions, company, formName, navigate]);

  const permissionsFlags = useMemo(() => {
    if (!company || !permissionsFromForm) {
      return {
        canInsert: false,
        canView: false,
        canEdit: false,
        canImport: false,
        canDelete: false,
        canViewArchived: false,
        canViewFinal: false
      };
    }

    const canInsert = checkPermission(permissionsFromForm, 'INSERT_DATA_IN_FORM', company.unitId, 'form', null, formName);
    const canView = checkPermission(permissionsFromForm, 'VIEW_DATA_FROM_FORM', company.unitId, 'form', null, formName);
    const canEdit = checkPermission(permissionsFromForm, 'EDIT_DATA_IN_FORM', company.unitId, 'form', null, formName);
    const canImport = checkPermission(permissionsFromForm, 'IMPORT_DATA_IN_FORM', company.unitId, 'form', null, formName);
    const canDelete = checkPermission(permissionsFromForm, 'DELETE_DATA_IN_FORM', company.unitId, 'form', null, formName);
    const canViewArchived = checkPermission(permissionsFromForm, 'VIEW_DATA_ARCHIVED_FROM_FORM', company.unitId, 'form', null, formName);

    return {
      canInsert,
      canView,
      canEdit,
      canImport,
      canDelete,
      canViewArchived,
      canViewFinal: canInsert || canView || canEdit
    };
  }, [company, permissionsFromForm, formName]);

  return {
    permissions,
    company,
    permissionsFromForm,
    ...permissionsFlags
  };
};

export default useRecordsPermissions;
